// MANAGE
export const RESET_ALL_STATES = "RESET_ALL_STATES";
export const SET_IS_ACTIVE = "SET_IS_ACTIVE";
export const SET_STAGE = "SET_STAGE";
export const SET_NAME = "SET_NAME";
export const SET_STARTS_AT = "SET_STARTS_AT";
export const SET_ENDS_AT = "SET_ENDS_AT";
export const SET_DURATION = "SET_DURATION";
export const SET_DURATION_TYPE = "SET_DURATION_TYPE";
export const SET_ATTEMPTS_ALLOWED = "SET_ATTEMPTS_ALLOWED";
export const SET_VISIBILITY_PRIVATE = "SET_VISIBILITY_PRIVATE";
export const SET_IS_VIDEO_PROCTORING_ON = "SET_IS_VIDEO_PROCTORING_ON";
export const SET_IS_TAB_PROCTORING_ON = "SET_IS_TAB_PROCTORING_ON";
export const SET_ID = "SET_ID";
export const SET_STATE = "SET_STATE";
export const SET_ALL_STATES = "SET_ALL_STATES";
export const SET_QUESTION_STATES = "SET_QUESTION_STATES";
export const SET_TRIGGER = "SET_TRIGGER";
export const SET_SECTIONS = "SET_SECTIONS";
export const SET_CURRENT_SECTION_INDEX = " SET_CURRENT_SECTION_INDEX";
export const SET_CURRENT_SECTION_TITLE = " SET_CURRENT_SECTION_TITLE";
export const SET_EDIT_CURRENT_SECTION = " SET_EDIT_CURRENT_SECTION";
export const SET_SHOW_ADD_QUESTION_MODAL = " SET_SHOW_ADD_QUESTION_MODAL";
export const SET_QUESTION_TYPE = "SET_QUESTION_TYPE";
export const SET_QUESTION_OPTIONS = "SET_QUESTION_OPTIONS";
export const SET_QUESTIONS = "SET_QUESTIONS";
export const SET_QUESTION = "SET_QUESTION";
export const SET_QUESTION_ANSWERS = "SET_QUESTION_ANSWERS";
export const SET_ALLOWED_ENTITIES = "SET_ALLOWED_ENTITIES";
export const SET_TEST_INSTRUCTION = "SET_TEST_INSTRUCTION";
export const SET_PASSING_PERCENTAGE = "SET_PASSING_PERCENTAGE";

// ATTEMPT
export const SET_ASSESSMENT = "SET_ASSESSMENT";
export const SET_CURRENT_QUESTION = "SET_CURRENT_QUESTION";
export const SET_CURRENT_ANSWER = "SET_CURRENT_ANSWER";
export const SET_CURRENT_SECTION = "SET_CURRENT_SECTION";
export const NEXT = "NEXT";
export const PREVIOUS = "PREVIOUS";
export const SET_SUPPORT_WIDGET_VISIBILITY = "SET_SUPPORT_WIDGET_VISIBILITY";
export const END_ASSESSMENT = "END_ASSESSMENT";
export const RESET_ATTEMPT = "RESET_ATTEMPT";
export const SET_ATTEMPT_EMBEDDED = "SET_ATTEMPT_EMBEDDED";
export const START_SYNC = "START_SYNC";
export const END_SYNC = "END_SYNC";
export const START_VIDEO_RECORDING = "START_VIDEO_RECORDING";
export const END_VIDEO_RECORDING = "END_VIDEO_RECORDING";
